export default "__VITE_ASSET__94b32dc2__"